import { Action } from '../../common/actions/core/action';

export class PromocodeHasPackageAction implements Action {
  constructor(public url: string) { }
}


// WEBPACK FOOTER //
// src/app/components/promocode-has-package/promocode-has-package.action.ts